"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _avatarModule = _interopRequireDefault(require("./avatar.module.css"));

const Avatar = _ref => {
  let {
    className,
    darkText,
    image,
    fullName,
    withText,
    stackedText,
    title,
    imageFallback,
    forceAspectRatio,
    classNames
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(_avatarModule.default.avatar, stackedText && _avatarModule.default.stackedText)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(_avatarModule.default.photo, className)
  }, /*#__PURE__*/_react.default.createElement("svg", {
    className: (0, _clsx.default)(_avatarModule.default.svg, stackedText && _avatarModule.default.stackedText, classNames.svg),
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 112 111"
  }, /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#4A5D72",
    strokeLinecap: "round",
    strokeWidth: "5",
    opacity: darkText ? '0.2' : '0.25',
    transform: "translate(2 2)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    strokeDasharray: "50 54",
    d: "M54,106 C83.2710917,106 107,82.2710917 107,53 C107,23.7289083 83.2710917,0 54,0 C24.7289083,0 1,23.7289083 1,53 C1,82.2710917 24.7289083,106 54,106 Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    strokeDasharray: "5 100",
    d: "M53.8139581,106.817387 C83.0850499,106.817387 106.813958,83.0884789 106.813958,53.8173872 C106.813958,24.5462954 83.0850499,0.817387157 53.8139581,0.817387157 C24.5428664,0.817387157 0.813958125,24.5462954 0.813958125,53.8173872 C0.813958125,83.0884789 24.5428664,106.817387 53.8139581,106.817387 Z",
    transform: "rotate(-90 53.814 53.817)"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(_avatarModule.default.imageContainer, classNames.imageContainer)
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: (0, _clsx.default)(_avatarModule.default.image, forceAspectRatio && _avatarModule.default.forceAspectRatio, classNames.image),
    src: image,
    alt: fullName || 'Profile Photo',
    onError: e => {
      e.target.onerror = null;
      e.target.src = imageFallback;
    }
  }))), withText ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(_avatarModule.default.info, darkText && _avatarModule.default.darkText, stackedText && _avatarModule.default.stackedText, classNames.text)
  }, /*#__PURE__*/_react.default.createElement("h3", null, fullName), /*#__PURE__*/_react.default.createElement("h6", null, title)) : null);
};

Avatar.defaultProps = {
  image: 'https://s3-us-west-2.amazonaws.com/observian-team/assets/avatar.png',
  fullName: 'Default Name',
  title: 'Default Title',
  withText: false,
  stackedText: false,
  darkText: false,
  className: '',
  classNames: {},
  imageFallback: 'https://s3-us-west-2.amazonaws.com/observian-team/assets/avatar.png',
  forceAspectRatio: false
};
Avatar.propTypes = {
  image: _propTypes.default.string,
  fullName: _propTypes.default.string,
  title: _propTypes.default.string,
  className: _propTypes.default.string,
  classNames: _propTypes.default.shape({
    root: _propTypes.default.string,
    svg: _propTypes.default.string,
    imageContainer: _propTypes.default.string,
    image: _propTypes.default.string,
    text: _propTypes.default.string
  }),
  withText: _propTypes.default.bool,
  stackedText: _propTypes.default.bool,
  darkText: _propTypes.default.bool,
  imageFallback: _propTypes.default.string,
  forceAspectRatio: _propTypes.default.bool
};
var _default = Avatar;
exports.default = _default;